import React from 'react';
import {
	IOS_APP_STORE_URL,
	ANDROID_PLAY_STORE_URL,
} from 'constants/appStoreLinks';
import { Row, BadgeLink, Badge } from './styled';

/**
 * App Store / Google Play links.
 *
 * Uses the official badge artwork rather than a Flass-styled button: on a
 * public marketing page these are recognized trust marks, and both stores'
 * brand guidelines require their own artwork rather than a recolored
 * substitute. Each badge is pre-letterboxed onto an identical canvas so the
 * two render at the same size without stretching either logo.
 *
 * Renders nothing if neither URL is set, and just one badge if only one is —
 * so a future platform gap never leaves a dead link on the page.
 */
const StoreBadges = ({ className }) => {
	if (!IOS_APP_STORE_URL && !ANDROID_PLAY_STORE_URL) return null;

	return (
		<Row className={className}>
			{IOS_APP_STORE_URL ? (
				<BadgeLink
					href={IOS_APP_STORE_URL}
					target='_blank'
					rel='noopener noreferrer'
				>
					<Badge
						src='/app-store-badge.png'
						alt='Download Flass on the App Store'
						width='168'
						height='50'
						loading='lazy'
					/>
				</BadgeLink>
			) : null}
			{ANDROID_PLAY_STORE_URL ? (
				<BadgeLink
					href={ANDROID_PLAY_STORE_URL}
					target='_blank'
					rel='noopener noreferrer'
				>
					<Badge
						src='/google-play-badge.png'
						alt='Get Flass on Google Play'
						width='168'
						height='50'
						loading='lazy'
					/>
				</BadgeLink>
			) : null}
		</Row>
	);
};

export default StoreBadges;
